/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesUnitsStatus200, GetUsersPreferencesUnitsStatus401 } from '../types/GetUsersPreferencesUnits'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesUnits } from '../clients/getUsersPreferencesUnits'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersPreferencesUnitsQueryKey = () => [{ url: '/users/preferences/units/' }] as const

type GetUsersPreferencesUnitsQueryKey = ReturnType<typeof getUsersPreferencesUnitsQueryKey>

export function getUsersPreferencesUnitsQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesUnitsQueryKey()
  return queryOptions<GetUsersPreferencesUnitsStatus200, ResponseErrorConfig<GetUsersPreferencesUnitsStatus401>, GetUsersPreferencesUnitsStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesUnits({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/units/}
 */
export function useGetUsersPreferencesUnits<TData = GetUsersPreferencesUnitsStatus200, TQueryData = GetUsersPreferencesUnitsStatus200, TQueryKey extends QueryKey = GetUsersPreferencesUnitsQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetUsersPreferencesUnitsStatus200, ResponseErrorConfig<GetUsersPreferencesUnitsStatus401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesUnitsQueryKey()

  const queryResult = useQuery({
   ...getUsersPreferencesUnitsQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesUnitsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
